<template>
  <div class="company-appointment-box">
    <div
      class="company-appointment-content"
      :style="{
        background:
          'url(' +
          cdnresources +
          '/prod/images/xiangaibao/company-banner.png) top/100% auto no-repeat #F5F4F7'
      }"
    >
      <div class="title-box"></div>
      <div class="form-box">
        <van-form
          :show-error="false"
          :validate-first="false"
          ref="formData"
          @submit="submit"
        >
          <div class="tips-info">企业名称</div>
          <van-field
            class="input-ele"
            v-model="companyName"
            name="companyName"
            placeholder="请输入企业名称"
            :rules="formRules.companyName"
            clearable
          />
          <div class="tips-info">联系人</div>
          <van-field
            class="input-ele"
            v-model="contactPerson"
            name="validator"
            placeholder="请输入联系人"
            :rules="formRules.contactPerson"
            clearable
          />
          <div class="tips-info">联系电话</div>
          <van-field
            class="input-ele"
            v-model.trim="contactTel"
            name="contactTel"
            placeholder="请输入联系电话"
            :rules="formRules.contactTel"
            clearable
          />
          <div class="tips-info">企业地址</div>
          <van-field
            class="input-ele"
            v-model.trim="address"
            name="address"
            placeholder="请输入企业地址"
            :rules="formRules.address"
            clearable
          />
          <!-- <div class="tips-info">推荐公司(非必填)</div> -->
          <!-- <van-field class="input-ele" v-model="referrer" name="referrer" placeholder="请输入推荐公司" :rules="formRules.referrer" clearable /> -->
          <!-- <van-field class="input-ele" v-model="referrer" name="referrer" placeholder="请输入推荐公司" :rules="formRules.referrer" readonly clickable   @click="showPicker = true"/>    -->

          <div class="customer-tips-info">客户专员将于24小时内联系您的企业</div>
        </van-form>
        <van-popup v-model="showPicker" position="bottom">
          <van-picker
            show-toolbar
            :columns="columns"
            @confirm="onConfirm"
            @cancel="showPicker = false"
          />
        </van-popup>
      </div>
      <div>
        <van-button
          id="Enterprise_Reservation_Submit"
          class="submit-btn"
          round
          block
          type="submit"
          native-type="submit"
          @click="send"
        >
          提交
        </van-button>
      </div>
    </div>
    <!-- <van-dialog v-model="vcodeshow"
                @confirm="confirmsf"
                show-cancel-button>
      <van-field v-model="sms"
                 center
                 clearable
                 placeholder="请输入验证码"
                 class="sf">
        <template #button>
           <van-image @click="ckpicturecaptcha" width="80" height="35" :src="sf"/>
        </template>
      </van-field>
    </van-dialog> -->
  </div>
</template>

<script>
  import { saveCompanyAppointmentInfo } from '@/api/company-appointment'
  import { SetCompanyAppointmentShare } from '@/util/set-wx-share'
  import {
    CHECK_NAME,
    CHECK_TELL_PHONE
    // CHECK_MOBILE_PHONE
  } from '../../util/validate'
  import { cdnresources } from '@/util/config'
  export default {
    name: 'CompanyAppointment',
    components: {},
    mixins: [],
    props: {},
    data() {
      return {
        cdnresources,
        sf: '',
        sms: '',
        // vcodeshow: false,
        showPicker: false,
        columns: [
          '太平洋财产保险',
          '中国人寿保险',
          '中国人保财险',
          '太平人寿保险',
          '华安财产保险'
        ],
        companyName: '',
        contactPerson: '',
        contactTel: '',
        address: '',
        referrer: '',
        formRules: {
          companyName: [
            { required: true, message: '请填写企业名称' },
            {
              validator: this.checkCompanyNameLength,
              message: '请输入正确的企业名称，2-30个字'
            }
          ],
          contactPerson: [
            { required: true, message: '请填写联系人' },
            {
              validator: this.cnNameValidator,
              message: '联系人姓名由中文构成，2-20个汉字'
            }
          ],
          contactTel: [
            // {
            //   validator: this.checkPhoneType,
            //   message: '请输入数字'
            // },
            {
              required: true,
              message: '请输入联系电话'
            },
            {
              validator: this.checkTellPhone,
              message: '请输入正确的联系电话：座机(带区号)、手机'
            }
          ],
          address: [
            { required: true, message: '请填写企业地址' },
            {
              validator: this.checkAddress,
              message: '地址长度不能少于10位且不超过50位'
            }
          ],
          referrer: [
            {
              validator: this.checkReferrerLength,
              message: '推荐公司姓名由中文构成，2-20个汉字'
            }
          ]
        },
        regValid: /\d{6}/
      }
    },
    computed: {},
    watch: {},
    created() {},
    mounted() {
      SetCompanyAppointmentShare()
    },
    destroyed() {},
    methods: {
      ckpicturecaptcha() {
        const d = new Date().getTime()
        this.sf = `${process.env.VUE_APP_API_PATH}/services/web/memberResource/getImageVerifyCode?busId=${this.contactTel}&id=${d}`
      },
      async confirmsf() {
        const toast = this.$toast.loading({
          duration: 0, // 持续展示 toast
          forbidClick: true,
          message: '加载中...'
        })
        const data = {
          companyName: this.companyName,
          contactPerson: this.contactPerson,
          contactTel: this.contactTel,
          address: this.address,
          referrer: this.referrer,
          // beforeCaptcha: this.sms,
          openId: this.$store.state.userInfo.openId || ''
        }
        try {
          await saveCompanyAppointmentInfo(data)
          this.companyName = ''
          this.contactPerson = ''
          this.contactTel = ''
          this.address = ''
          this.referrer = ''
          this.$toast.success(
            '企业参保信息提交成功，专员将在1个工作日内联系您。'
          )
        } catch (e) {
          this.$notify({ type: 'danger', message: e.message })
        }
        toast.clear()
      },
      onConfirm(value) {
        this.referrer = value
        this.showPicker = false
      },
      checkCompanyNameLength(val) {
        if (val.length < 2 || val.length > 30) {
          return false
        }
      },
      // 校验姓名规则为中文
      cnNameValidator(val) {
        console.log(val, CHECK_NAME(val))
        return CHECK_NAME(val)
      },
      // // 判断手机号类型
      // checkPhoneType(val) {
      //   if (isNaN(val)) {
      //     return false
      //   }
      // },
      // 判断手机号位数是否低于5位
      checkPhoneLengthFive(val) {
        if (val.length < 5 || val.length > 13) {
          return false
        }
      },
      // 校验座机
      checkTellPhone(val) {
        if (val) {
          return CHECK_TELL_PHONE(val)
        }
      },
      // 判断手机号为11位时，校验手机号码规则
      // checkMobilePhone(val) {
      //   if (val.length === 11 && val[0] === '1') {
      //     return CHECK_MOBILE_PHONE(val)
      //   } else {
      //     return true
      //   }
      // },
      // 地址位数
      checkAddress(val) {
        if (val.length < 10 || val.length > 50) {
          return false
        }
      },
      checkReferrerLength(val) {
        if (val) {
          return CHECK_NAME(val)
        }
      },
      async submit() {
        // const d = new Date().getTime()
        // this.sf = `${process.env.VUE_APP_API_PATH}/services/web/memberResource/getImageVerifyCode?busId=${this.contactTel}&id=${d}`
        // this.vcodeshow = true
        this.confirmsf()
      },
      send() {
        this.$refs.formData.submit()
      }
    }
  }
</script>

<style scoped lang="scss">
  .company-appointment-box {
    min-height: 100vh;
  }
  .company-appointment-content {
    min-height: 100vh;
    padding: 0 px2vw(72) px2vw(30);
  }

  .title-box {
    color: #fff;
    padding-top: px2vw(20);
    // padding-left: px2vw(40);
    font-size: px2rem(86);
    font-weight: 400;
    margin: 0;
  }
  .le-chen-title {
    padding-top: px2vw(20);
    font-size: px2rem(63);
    margin-bottom: px2rem(20);
    padding-left: px2vw(16);
    font-weight: 700;
    color: #fff;
  }
  .form-box {
    background-color: #fff;
    border-radius: px2vw(20);
    padding: 0 px2vw(40) px2vw(50);
    margin: px2vw(360) auto 0;
    font-size: xvw(40);
    color: #000000;

    & .van-field {
      border: none;

      & .van-field__control {
        outline: none;
      }
    }
  }

  .tips-info {
    font-size: xvw(30);
    font-weight: 700;
    padding-top: px2vw(60);
    margin-bottom: px2vw(20);
    color: #333;
  }
  .input-ele {
    font-size: px2rem(16, 375);
    padding-top: 2px;
  }
  .customer-tips-info {
    margin-top: px2vw(60);
    margin-bottom: px2vw(20);
    font-size: xvw(26);
    text-align: left;
  }

  .submit-btn {
    background: linear-gradient(135deg, #ff7828 0%, #ff282c 100%);
    border: none;
    outline: none;
    font-size: px2rem(46);
    margin-top: px2rem(20, 375);
    color: #fff;
    height: px2rem(50, 375);
  }
  /deep/.van-cell {
    padding: 0px;
  }
  /deep/.van-cell::after {
    border-bottom-color: #ccc;
    left: 0px;
  }
</style>
